import {Outlet} from "react-router-dom";

const Template = () => {
    return (
        <div className={''}>
            <Outlet/>
        </div>
    )
}
export default Template